export var PaymentMethods;
(function (PaymentMethods) {
    // eslint-disable-next-line no-unused-vars
    PaymentMethods["EXPRESS"] = "EXPRESS";
    // eslint-disable-next-line no-unused-vars
    PaymentMethods["OFFERER"] = "OFFERER";
    // eslint-disable-next-line no-unused-vars
    PaymentMethods["OFFERER_PLUS_EMAIL"] = "OFFERER_PLUS_EMAIL";
})(PaymentMethods || (PaymentMethods = {}));
//# sourceMappingURL=Checkout.js.map